import React, { useEffect } from "react";

// Componentes comunes
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import useStore from "../store/useStore";
import Seo from "../components/Seo";
import Diagrams from "../components/Diagram";
import CardBeneficios from "../components/CardBeneficios";

// Lista de beneficios a mostrar (contenido estático)
const productos = [
  {
    title: "Automatización de pagos",
    description:
      "Automatice el pago de gravámenes, con la generación y el pago del VEP en el momento exacto de la nacionalización de la mercadería para evitar la inmovilización de fondos en la cuenta María.",
  },
  {
    title: "Gestión de pagos con códigos QR",
    description:
      "Simplifique la gestión de pagos a terminales portuarias, depósitos fiscales, aeropuertos, trámites de AFIP con un lector de QR vinculado directamente a la cuenta bancaria de la compañía y con permisos diferenciados de pagos para cada usuario.",
  },
  {
    title: "Inversiones más eficientes y menos pérdidas",
    description:
      "Rentabilice diariamente los fondos depositados en la billetera, a través de los únicos prestadores de servicios de pago homologados por BCRA y la única billetera recaudadora de AFIP del comercio exterior.",
  },
  {
    title: "Inversiones más eficientes y menos pérdidas",
    description:
      "Elimina la inmovilización y desvíos de dinero, permitiendo invertir de forma estratégica en mejores oportunidades.",
  },
];

export default function Pay() {
  // Extrae data del store global (Zustand)
  const { payHeroes, getPayHeroes, seoPays, fetchSeoPays } = useStore();
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  // Carga los datos al montar el componente
  useEffect(() => {
    getPayHeroes();
    fetchSeoPays();
  }, [getPayHeroes, fetchSeoPays]);

  return (
    <>
      {/* SEO dinámico para la página */}
      <Seo
        metaTitle={seoPays[0]?.metatitle}
        metaDescription={seoPays[0]?.metadescription}
        metaImage={seoPays[0]?.metaimage?.url}
        metaKeywords={seoPays[0]?.metakeywords}
        canonicalURL={seoPays[0]?.canonicalurl}
      />

      {/* Encabezado */}
      <header>
        <Navbar tabIndex={0} aria-label="Navegación principal" />
      </header>

      {/* Contenido principal */}
      <main className="bg-sidom-light dark:bg-sidom-blue">
        {/* Hero dinámico o placeholder si aún no se carga */}
        <section>
          {payHeroes?.length === 0 || !payHeroes ? (
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
              tabIndex={0}
              aria-label="Video de carga"
            />
          ) : (
            payHeroes.map((item, index) => (
              <VideoBackground
                key={index}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="SOLICITAR DEMO"
                link="/contact"
                logo={`${urlApi}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
                tabIndex={0}
                aria-label={`Video de ${item.titulo}`}
              />
            ))
          )}
        </section>

        {/* Sección: ¿Qué es SIDOM Pay? */}
        <section>
          <div className="container">
            <div className="mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0 flex h-full">
              <div className="flex flex-col">
                <h1
                  className="leading-[1.3] mb-[30px] text-sidom-orange dark:text-sidom-light text-[45px] font-extrabold text-left"
                  tabIndex={0}
                  aria-label="Título: ¿Qué es SIDOM Pay?"
                >
                  ¿Qué es SIDOM Pay?
                </h1>
                <div
                  className="text-xs sm:text-sm md:text-base lg:text-xl text-left leading-relaxed"
                  tabIndex={0}
                  aria-label="Descripción de SIDOM Pay"
                >
                  <p className="mb-4">
                    La primera billetera virtual que automatiza, centraliza y
                    gestiona todos los procesos de pagos de comercio exterior.
                    Redefinimos el concepto de los pagos aduaneros al crear el
                    primer y único botón de la región que automatiza el proceso
                    en su totalidad, co creado junto al feedback de las
                    compañías líderes en el mercado, nuestros clientes.
                  </p>
                  <p>
                    SIDOM Pay es la revolución del comercio exterior a través de
                    su botón de pago único, diseñado para transacciones B2B
                    Comex a través de un Débito Inteligente desde cualquier
                    cuenta bancaria. Este sistema innovador simplifica la
                    oficialización y gestión de liquidaciones manuales,
                    transformando la experiencia de pago en un proceso
                    automático, eficiente y seguro.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Sección con el diagrama visual */}
        <section className="">
          <Diagrams tabIndex={0} aria-label="Diagrama visual de SIDOM Pay" />
        </section>

        {/* Sección de beneficios listados */}
        <section className="container mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0">
          <div className="flex flex-col container">
            <h1
              className="text-sidom-orange mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[60px] text-3xl md:text-[40px] lg:text-[45px] leading-tight font-extrabold text-left"
              tabIndex={0}
              aria-label="Título: Beneficios"
            >
              Beneficios
            </h1>

            {/* Render de cada tarjeta de beneficio */}
            <div>
              {productos.map((producto, index) => (
                <CardBeneficios
                  key={index}
                  titulo={producto.title}
                  descripcion={producto.description}
                  tabIndex={0}
                  aria-label={`Beneficio: ${producto.title}`}
                />
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer>
        <Footer tabIndex={0} aria-label="Pie de página" />
      </footer>

      {/* Botón flotante de color/tema */}
      <Switcher tabIndex={0} aria-label="Botón para cambiar tema" />
    </>
  );
}
